module.exports = __webpack_public_path__ + "img/1006821726.41706979.png";